import {ThunkDispatch} from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import {connect, useDispatch } from "react-redux"
import { useEffect } from "react";
import NewRoomDesign from './NewRoomDesign'
import AccountManage from '../pages/AccountManage'
import GeneralUserManage from "../pages/GeneralUserManage";
import { RoleTypeExtension } from "../constants";

function mapStateToProps(state: any) {
  return { ...state.currentUser }
}

const Home = (props: any) => {
  const {is_staff, roleType} = props
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()

  if (is_staff) return (
    <AccountManage />
  )
  if (RoleTypeExtension.isViewer(roleType)) return (
    <GeneralUserManage />
  )
  return (
    <NewRoomDesign />
  )
};

export default connect(mapStateToProps)(Home)